import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import gallery1 from "./../assets/gallery1.jpg";
import gallery2 from "./../assets/gallery2.jpg";
import gallery3 from "./../assets/gallery3.jpg";
import gallery4 from "./../assets/gallery4.jpg";
import gallery5 from "./../assets/gallery5.jpg";
import gallery6 from "./../assets/gallery6.jpg";
import gallery7 from "./../assets/gallery7.jpg";
import gallery8 from "./../assets/gallery8.jpg";
import gallery9 from "./../assets/gallery9.jpg";
import gallery10 from "./../assets/gallery10.jpg";

const photos1 = [gallery1, gallery6, gallery2, gallery7, gallery3];
const photos2 = [gallery8, gallery4, gallery9, gallery5, gallery10];

const SlideSet = ({ photos }) => (
  <div className="px-4">
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
      {photos.map((photo, index) => (
        <div
          key={index}
          className="group relative overflow-hidden rounded-3xl shadow-soft hover:shadow-soft-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer"
        >
          <div className="aspect-w-3 aspect-h-3">
            <img
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              src={photo}
              alt={`Galería imagen ${index + 1}`}
              loading="lazy"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-primary/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-3xl" />
        </div>
      ))}
    </div>
  </div>
);

export default function Gallery() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    dotsClass: "slick-dots !bottom-[-32px]",
  };

  return (
    <section className="bg-primary-lighter overflow-hidden py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-block bg-white text-primary font-body font-semibold text-sm px-4 py-1.5 rounded-full mb-3 shadow-soft">
            Momentos
          </span>
          <h2 className="font-heading text-4xl sm:text-5xl font-semibold text-gray-800">
            Galería
          </h2>
          <p className="mt-3 text-gray-500 font-body text-base max-w-md mx-auto">
            Un vistazo a nuestras sesiones y momentos especiales
          </p>
        </div>

        <div className="pb-12">
          <Slider {...settings}>
            <SlideSet photos={photos1} />
            <SlideSet photos={photos2} />
          </Slider>
        </div>
      </div>

      {/* Wave */}
      <div className="w-full overflow-hidden leading-none mt-8">
        <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" preserveAspectRatio="none">
          <path d="M0,20 C360,60 1080,0 1440,30 L1440,60 L0,60 Z" fill="#ffffff" />
        </svg>
      </div>
    </section>
  );
}
